import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {CustomerPortalResponse} from '@app/model/psp-integration/customer-portal-response.model';
import {DcpStripeService} from '@app/payment/services/stripe/dcp-stripe.service';
import {isPlatformBrowser} from '@angular/common';
import {DcpError} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'dcp-billing',
  templateUrl: './billing.component.html',
})
export class BillingComponent implements OnInit {
  customerPortalError: DcpError;

  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    private dcpStripeService: DcpStripeService) {
  }

  ngOnInit(): void {
    this.dcpStripeService.createCustomerPortalSession()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (cpr: CustomerPortalResponse) => {
          if (isPlatformBrowser(this.platformId)) {
            window.location.href = cpr.targetUrl;
          }
        },
        error: e => {
          this.customerPortalError = {
            errorCode: e.error?.errors?.length > 0 ? e.error.errors[0].errorCode : undefined,
            isEligibleForRetry: false,
            hasError: true,
            description: e.error?.errors?.length > 0 ? e.error.errors[0].message : undefined
          };
          throw e;
        },
      });
  }
}
